import React from "react";
import Remove from "../../../assets/svgs/Remove";
import Check from "../../../assets/svgs/Check";
import Info from "../../../assets/svgs/Info";
import { useRootContext } from "../../../context";

const SupportPopup = () => {
  const { dispatch } = useRootContext();
  return (
    <div className="fixed z-50 inset-0 m-auto mx-5 sm:mx-0 sm:pt-32">
      <div
        onClick={() => dispatch({ type: "toggle_support_req" })}
        className="fixed inset-0 m-auto bg-black bg-opacity-20 z-30"
      />
      <div className="flex flex-col-reverse sm:flex-row justify-center">
        <div className="relative z-50 w-full sm:w-80 sm:border-r-4 border-gray-300 bg-gray-50 sm:shadow-md px-3 py-2 rounded">
          <h3 className="text-sm font-medium pt-5">Service Request</h3>
          <br />
          <p className="px-3">Samuel L. Davis Requested a new service.</p>
          <div className="px-3">
            <p>
              <small>Account</small>
            </p>
            <input
              className="bg-transparent outline-none py-1 border-b-2 border-gray-500"
              type="text"
              placeholder="sam@davis.me"
              name=""
            />
          </div>
          <div className="my-4 text-center">
            <p className="text-xs">
              <small>Date</small>
            </p>
            <p className="font-normal">27 May</p>
          </div>
          <div className="flex justify-center relative pb-10">
            <button className="flex items-center justify-center w-10 h-10 bg-white rounded-full shadow-md">
              <Remove />
            </button>
            <div className="mx-2" />
            <button className="flex items-center justify-center w-10 h-10 bg-pink-600 text-white rounded-full shadow-md">
              <Check />
            </button>
            <button className="absolute bottom-4 inset-x-0 mx-auto text-center flex justify-center">
              <Info />
            </button>
          </div>
        </div>
        <div className="relative z-50 w-full sm:w-80 bg-gray-50 sm:shadow-md rounded px-5 mt-5 sm:mt-0 ">
          <div className="flex justify-between py-5">
            <h3 className="text-base font-medium">Message</h3>
            <button onClick={() => dispatch({ type: "toggle_support_req" })}>
              <Remove />
            </button>
          </div>
          <textarea
            className="w-full h-60 box-while p-2 bg-gray-100 focus:outline-slate-300"
            placeholder="Type here..."
          ></textarea>
        </div>
      </div>
    </div>
  );
};

export default SupportPopup;
